// extracted by css-extract-rspack-plugin
export default {"transcript":"I9fSJVHbR70EmUHg","transcriptInner":"gMxfqw1KjD0JQqSO"};